import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import type { RootState } from 'src/app/store/types';
import { usePassengersListQuery } from 'src/common/external/bambi-api/bambiApi';
import { formatFullName } from 'src/common/util/formatFullName';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export const usePassengerMultiSelectData = () => {
  const open = useSelector(
    (state: RootState) => state.trip.showDownloadDetailsModal
  );

  const [selectedPassengers, setSelectedPassengers] = useState<
    SelectOption[] | undefined
  >(undefined);
  const [passengerSearchTerm, setPassengerSearchTerm] = useState<string>('');
  const { data: passengers, isLoading: isLoadingPassengers } =
    usePassengersListQuery({ search: passengerSearchTerm }, { skip: !open });

  const passengerOptions = passengers?.results
    ? passengers.results.map((passenger) => ({
        label: formatFullName(passenger),
        value: passenger.id,
      }))
    : [];

  useEffect(() => {
    // Reset the state when the modal is closed
    if (!open) {
      setSelectedPassengers(undefined);
      setPassengerSearchTerm('');
    }
  }, [open]);

  return {
    selectedPassengers,
    setSelectedPassengers,
    passengerSearchTerm,
    setPassengerSearchTerm,
    passengerOptions,
    isLoadingPassengers,
  };
};
